const ControlOptions = {
  BACKGROUNDCOLOR: 'BackgroundColor',
  POSITION: 'Position',
  LIST3GROUPSTYPE: 'List3GroupsType',
  HEROTYPE: 'HeroType',
  WELLTYPE: 'WellType',
  PAGETAG: 'PageTag',
  QUOTETYPE: 'QuoteType',
  HEADERTEXTGROUPTYPE: 'HeaderTextGroupType',
  CALLTOACTIONTYPE: 'CallToActionType',
  CALLTOACTIONWITHALIGNMENTTYPE: 'CallToActionWithAlignmentType',
  KEYFIGUREGRIDTYPE: 'KeyFigureGridType',
  PROFILEGRIDTYPE: 'ProfileGridType',
  PROFILETYPE: 'ProfileType',
  SEOWEIGHT: 'SEOWeight',
  BODYTEXTWIDTH: 'BodyTextWidth',
};

module.exports = ControlOptions;
